import { useEffect } from 'react';
import { io } from 'socket.io-client';

const apiPath = process.env.REACT_APP_API_URL;
const socketPath = apiPath?.replace(/\/api\/?$/, '');

const socket = io(socketPath);

export function useNotificationSocket(onCreated: () => Promise<void> | void) {
  useEffect(() => {
    socket.on('createdNotification', onCreated);

    return () => {
      socket?.off('createdNotification', onCreated);
    };
  }, [onCreated]);
}
